// Copyright (c) 2024 WiseTime. All rights reserved.

export const draggableListKey = "draggable-list-key"
